export default "__VITE_ASSET__BTVnGOEq__"